import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { User } from 'types/embedded/user';
import { getId } from 'utils';

import { UsersMerchantAccessDialogForm } from './UsersMerchantAccessDialogForm';
import { useSaveUsersMerchantAccesses } from '../hooks/useSaveUsersMerchantAccesses';

type Props = {
  open: boolean;
  onClose: () => void;
  record?: User;
};

type FormValues = {
  merchantIds: string[];
  sourceUser: string | null;
};

export const UsersMerchantAccessDialog: React.FC<Props> = ({ open, onClose, record }) => {
  const form = useForm<FormValues>({
    defaultValues: { merchantIds: [], sourceUser: null },
  });

  const { handleSubmit } = form;
  const { mutate, isPending } = useSaveUsersMerchantAccesses(onClose, record);

  const onSubmit: SubmitHandler<FormValues> = ({ merchantIds }) => {
    if (!record?.id) {
      return;
    }

    mutate({
      userId: record.id,
      merchantIds: merchantIds.map((id) => Number(getId(id))),
    });
  };

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={[<CloseIconButton key="close" onClose={onClose} />]}
        title="Настроить доступ к мерчантам"
        titleSize="smallBold"
      />

      <FormProvider {...form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardContent>
            <UsersMerchantAccessDialogForm user={record} />
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <CancelButton key="cancel" onClick={onClose} variant="outlined" />,
              <SaveButton disabled={isPending} key="save" label="Сохранить" />,
            ]}
          />
        </form>
      </FormProvider>
    </Dialog>
  );
};
